import { RemarkButton } from '@Components/IconButton';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import { IClimateChangeStructureFormValues } from '../../EsgGreenhouseFormProvider/types';

export const BOARD_RES_REMARK_ID = 'board-responsibility-remark';

const BoardResponsibilityRemark = () => {
  const { control, getValues } = useGreenhouseForm();
  const { remark } =
    getValues(`climateChangeStructure.boardResponsibility`) ??
    ({} as IClimateChangeStructureFormValues);

  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const BoardResponsibilityEl = document.getElementById(BOARD_RES_REMARK_ID);

  const { completedSection } =
    useWatch({
      name: 'climateChangeStructure',
      control,
    }) ?? ({} as IClimateChangeStructureFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        BoardResponsibilityEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              onDelete={close}
              topic="บทบาทหน้าที่ของคณะกรรมการบริษัทในการกำกับดูแลด้านการเปลี่ยนแปลงสภาพภูมิอากาศ"
              setOpen={open}
              fieldPath="climateChangeStructure.boardResponsibility.remark"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          BoardResponsibilityEl
        )}
    </>
  );
};

export default BoardResponsibilityRemark;
